<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
                        
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="名称" prop="linkName" style="margin-right:15px">
              <el-input v-model="form.linkName" placeholder="请输入名称" :disabled="isDisabled" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="链接地址" prop="linkUrl" style="margin-right:15px">
              <el-input v-model="form.linkUrl" placeholder="请输入链接地址" :disabled="isDisabled" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="!isDisabled" slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'FriendsLinkEdit',
        data() {
            return {
                isDisabled: false,
                submitMethod: 'post',
                emptyForm:{},
                form: {
                    code: '',
                    userCode: '',
                    branchCode: '',
                    linkName: '',
                    linkUrl: '',
                },
                rules: {
                   
                    linkName: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    linkUrl: [
                        { required: true, message: '请输入邮件', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {
            //保存空表单对象
            this.emptyForm =JSON.parse(JSON.stringify(this.form))
        },
        methods: {
            init(isDisabled) {
                //查询到数据之前先展示空表单
                this.form = JSON.parse(JSON.stringify(this.emptyForm))
                this.isDisabled = isDisabled
                this.submitMethod = 'post' // 新增
            },
            // 获取页面信息
            getInfo(code) {
                this.submitMethod = 'put' // 编辑
                //查询到数据之前先展示空表单
                this.form=JSON.parse(JSON.stringify(this.emptyForm))
                request({ url: `/ntocc-basic-api/friendsLink/${code}`, method: 'get' }).then(response => {
                    this.form = response.data
                })
            },
            // 提交
            funcSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const data = this.form
                        request({ url: '/ntocc-basic-api/friendsLink', method: this.submitMethod, params: data }).then(response => {
                            this.$message({ message: response.msg, type: 'success' })
                            this.$emit('fatherEditMethod')
                        })
                    } else {
                        return false
                    }
                })
            },
            // 取消
            funcCancel() {
                this.$emit('fatherCancelMethod', 'edit')
            }

        }
    }
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
